var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3334 8.99984C17.3334 13.6022 13.6025 17.3332 9.00008 17.3332C4.39771 17.3332 0.666748 13.6022 0.666748 8.99984C0.666748 4.39746 4.39771 0.666504 9.00008 0.666504C13.6025 0.666504 17.3334 4.39746 17.3334 8.99984ZM10.2917 5.27069C10.2917 5.90352 9.77873 6.41652 9.1459 6.41652C8.51308 6.41652 8.00007 5.90352 8.00007 5.27069C8.00007 4.63786 8.51308 4.12486 9.1459 4.12486C9.77873 4.12486 10.2917 4.63786 10.2917 5.27069ZM8.00007 14.1249V7.45819H10.2917V14.1249H8.00007Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3334 8.99984C17.3334 13.6022 13.6025 17.3332 9.00008 17.3332C4.39771 17.3332 0.666748 13.6022 0.666748 8.99984C0.666748 4.39746 4.39771 0.666504 9.00008 0.666504C13.6025 0.666504 17.3334 4.39746 17.3334 8.99984ZM10.2917 5.27069C10.2917 5.90352 9.77873 6.41652 9.1459 6.41652C8.51308 6.41652 8.00007 5.90352 8.00007 5.27069C8.00007 4.63786 8.51308 4.12486 9.1459 4.12486C9.77873 4.12486 10.2917 4.63786 10.2917 5.27069ZM8.00007 14.1249V7.45819H10.2917V14.1249H8.00007Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.6f28d159e97e3f7f41316784fc9986b5.svg";
export { ForwardRef as ReactComponent };